import { render, staticRenderFns } from "./DepMana.vue?vue&type=template&id=621db645"
import script from "./DepMana.vue?vue&type=script&lang=js"
export * from "./DepMana.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports